"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ApproveEasyAddReviewReportParams () {
        return ApproveEasyAddReviewReportParams;
    },
    get CloseReviewReportParams () {
        return CloseReviewReportParams;
    },
    get InviteExternalAuthorReviewReportParams () {
        return InviteExternalAuthorReviewReportParams;
    },
    get RejectEasyAddReviewReportParams () {
        return RejectEasyAddReviewReportParams;
    },
    get ReopenReviewReportParams () {
        return ReopenReviewReportParams;
    },
    get SendBackReviewReportParams () {
        return SendBackReviewReportParams;
    },
    get SendBackReviewReportRequest () {
        return SendBackReviewReportRequest;
    },
    get SignOffReviewReportParams () {
        return SignOffReviewReportParams;
    },
    get SignOffReviewReportRequest () {
        return SignOffReviewReportRequest;
    },
    get SubmitReviewReportParams () {
        return SubmitReviewReportParams;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _utilsisomorphic = require("@performyard/utils-isomorphic");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const SubmitReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const SignOffReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const SendBackReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const SignOffReviewReportRequest = _zod.default.object({
    signOffComment: _zod.default.string().max(5000).default("")
});
const SendBackReviewReportRequest = _zod.default.object({
    sendBackComment: _zod.default.string().max(5000).default(""),
    phase: _zod.default.enum([
        "authors",
        "signers"
    ]).default("authors"),
    index: _zod.default.number().int().min(0).default(0)
});
const InviteExternalAuthorReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const ApproveEasyAddReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const RejectEasyAddReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const CloseReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
const ReopenReviewReportParams = _zod.default.object({
    reportId: _utilsisomorphic.transformObjectId
});
